import Volantino from './pages/volantino/volantino';

document.addEventListener('DOMContentLoaded', (e) => {
  new Volantino().init();
});
